import "./ManagerFontSetting.scss"

import React, { MouseEvent, useState } from "react"

import { ColorPicker } from "@shared/components"
import { useLayerPopupContext } from "@shared/contexts"
import { setManagerFont } from "@shared/modules"

import CheckableTag from "antd/lib/tag/CheckableTag"

import { FontSizeRatio } from "./FontSetting"

function ManagerFontSetting() {
  const { managerFont, close } = useLayerPopupContext()
  const fontSizeRatioOptions: FontSizeRatioOption[] = [
    { text: "가나다", value: "x-small" },
    { text: "가나다", value: "small" },
    { text: "가나다", value: "medium" },
    { text: "가나다", value: "large" },
  ]
  const [size, setSize] = useState<FontSizeRatio>(managerFont.size)
  const [color, setColor] = useState<string>(managerFont.color)
  const [isBold, setIsBold] = useState<boolean>(managerFont.isBold)

  const changeColor = (col: string) => {
    setColor(col)
  }

  return (
    <>
      <article
        className="popup managerFont"
        style={{
          width: "300px",
          margin: "-140px 0 0 -165px",
          display: "block",
        }}
      >
        <div className="titB">
          <h1>폰트설정</h1>
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="roundB">
            <ul className="radioB">
              {fontSizeRatioOptions.map((fontSizeRatioOption) => {
                return (
                  <li
                    key={fontSizeRatioOption.value}
                    style={{ fontSize: fontSizeRatioOption.value }}
                  >
                    <a
                      href="#!"
                      className={fontSizeRatioOption.value === size ? "on" : ""}
                      onClick={(e: MouseEvent) => {
                        e.preventDefault()
                        setSize(fontSizeRatioOption.value)
                      }}
                    >
                      <i>-</i>
                      {fontSizeRatioOption.text}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className="roundB colorB">
            <ul>
              <li title={"글자의 굵기는 설정 합니다"}>
                <CheckableTag
                  checked={isBold}
                  onChange={() => setIsBold(!isBold)}
                >
                  B
                </CheckableTag>
              </li>
              <li title={"글자의 색상을 지정 합니다"}>
                <ColorPicker changeColor={changeColor} />
              </li>
            </ul>
          </div>
        </div>
        <div className="btnB">
          <a
            href="#!"
            className="cancel"
            title="취소"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            취소
          </a>
          <a
            href="#!"
            title="적용"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              managerFont.handleManagerFont({ size, color, isBold })
              setManagerFont(size, color, isBold)
              close()
            }}
          >
            적용
          </a>
        </div>
      </article>
    </>
  )
}

export default ManagerFontSetting

type FontSizeRatioOption = { text: string; value: FontSizeRatio }
